import React from 'react';

function Cabinets() {
  return (
    <div>
      <h1 style={{ textTransform: 'uppercase' }}>CABINETS</h1>
      <p>Details on how to securely use the cabinets and storage solutions in your campervan.</p>
    </div>
  );
}

export default Cabinets;
